import { TaskCenterTypes } from '@frontend/api-task-center';
import { i18next } from '@frontend/i18n';
import { taskCenterTrackingIds } from './tracking-ids';
import { SelectedFilters } from './types';

const t = i18next.t;

// This type cast as const defines the source as a empty string literal type, it not specified it will throw an error
export const DEFAULT_FILTER_VALUES: SelectedFilters = {
  locations: [],
  source: '' as const,
  createdBy: '',
  sortType: null,
};

export const TASK_CENTER_CONSTANTS = {
  DEFAULT_TASK_LIMIT: 20,
  ANIMATION_DURATION: 0,
  PANEL_WIDTH: 'medium',
  DESCRIPTION_LIMIT: 300,
  DESCRIPTION_WARNING_LIMIT: 280,
  TITLE_LIMIT: 140,
  TITLE_WARNING_LIMIT: 120,
} as const;

export const TaskCenterTabs: {
  title: string;
  controller: string;
  status: TaskCenterTypes.TaskStatus;
  controls: string;
  trackingId: string;
}[] = [
  {
    title: t('To Do', { ns: 'task-center' }),
    controller: `controller-${TaskCenterTypes.TaskStatus.STATUS_TODO}`,
    status: TaskCenterTypes.TaskStatus.STATUS_TODO,
    controls: `controls-${TaskCenterTypes.TaskStatus.STATUS_TODO}`,
    trackingId: taskCenterTrackingIds.tabTodo,
  },
  {
    title: t('In Progress', { ns: 'task-center' }),
    controller: `controller-${TaskCenterTypes.TaskStatus.STATUS_IN_PROGRESS}`,
    status: TaskCenterTypes.TaskStatus.STATUS_IN_PROGRESS,
    controls: `controls-${TaskCenterTypes.TaskStatus.STATUS_IN_PROGRESS}`,
    trackingId: taskCenterTrackingIds.tabInprogress,
  },
  {
    title: t('Done', { ns: 'task-center' }),
    controller: `controller-${TaskCenterTypes.TaskStatus.STATUS_COMPLETED}`,
    status: TaskCenterTypes.TaskStatus.STATUS_COMPLETED,
    controls: `controls-${TaskCenterTypes.TaskStatus.STATUS_COMPLETED}`,
    trackingId: taskCenterTrackingIds.tabDone,
  },
];

export const TabsController: Record<
  'STATUS_TODO' | 'STATUS_IN_PROGRESS' | 'STATUS_COMPLETED',
  (typeof TaskCenterTabs)[number]['controller']
> = {
  [TaskCenterTypes.TaskStatus.STATUS_TODO]: TaskCenterTabs[0].controller,
  [TaskCenterTypes.TaskStatus.STATUS_IN_PROGRESS]: TaskCenterTabs[1].controller,
  [TaskCenterTypes.TaskStatus.STATUS_COMPLETED]: TaskCenterTabs[2].controller,
};

export const TaskStatusLabels = {
  [TaskCenterTypes.TaskStatus.STATUS_TODO]: t('To Do', { ns: 'task-center' }),
  [TaskCenterTypes.TaskStatus.STATUS_IN_PROGRESS]: t('In Progress', { ns: 'task-center' }),
  [TaskCenterTypes.TaskStatus.STATUS_COMPLETED]: t('Done', { ns: 'task-center' }),
};

export const TaskPriorityLabels = {
  [TaskCenterTypes.PriorityType.PRIORITY_HIGH]: t('High', { ns: 'task-center' }),
  [TaskCenterTypes.PriorityType.PRIORITY_MEDIUM]: t('Medium', { ns: 'task-center' }),
  [TaskCenterTypes.PriorityType.PRIORITY_LOW]: t('Low', { ns: 'task-center' }),
};

export const timeFormat = 'HH:mm:ss';
export const pickerDateFormat = 'MM/DD/YYYY';
export const DEFAULT_TASK_TIME = 11;
export const TaskDateTimeFormat = 'YYYY-MM-DDTHH:mm:00[Z]';
export const calendarDateFormat = 'YYYY-MM-DD';
